export function setTarifas(state, tarifas) {
    
    state.tarifas = tarifas;
    
}




export function actListTarifas(state, tarifa) {
    if (tarifa !== null) {
        const index = state.tarifas.findIndex(r => r.id === tarifa.id)
        if (index != -1) {
            state.tarifas.splice(index, 1, tarifa)   
        }
    }
  
}

export function actDeleteListTarifas(state, id) {
   
    if (id != null) {
        const index = state.tarifas.findIndex(r => r.id === id)
        if (index != -1) {
            state.tarifas.splice(index, 1)
        }
    }
}



export function setTarifaSelec(state, tarifa) {
    state.tarifaSelec = tarifa
}




